import SpotlightCard from '../../../components/effects/SpotlightCard';
import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import SectionIntro from '../../../components/ui/SectionIntro';
import { services } from '../../../content/site';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';
import ServiceIllustration from '../ServiceIllustration';

export default function ServicesSection() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.home.services;
  return (
    <section id="services" className="services-section section-pad">
      <div className="container">
        <SectionIntro title={copy.title} description={copy.description} />
        <FadeInOnScroll className="services-grid" delay={100}>
          {services.map((service) => (
            <Link
              key={service.key}
              className="service-card-link"
              to={localizedPath(locale, '/services')}
            >
              <SpotlightCard className="service-card" spotlightColor="rgba(255, 255, 255, 0.09)">
                <span className="service-card__icon" aria-hidden="true">
                  <ServiceIllustration kind={service.key} />
                </span>
                <div>
                  <h3>{messages.services[service.key].title}</h3>
                  <p>{messages.services[service.key].description}</p>
                </div>
                <span className="service-card__arrow">
                  <Arrow up />
                </span>
              </SpotlightCard>
            </Link>
          ))}
        </FadeInOnScroll>
        <div className="services-process">
          <div className="services-process__heading">
            <span>{copy.processLabel}</span>
            <Link className="text-link" to={localizedPath(locale, '/company/contact')}>
              {copy.talk} <Arrow />
            </Link>
          </div>
          <div className="services-process__steps">
            {copy.process.map((step, index) => (
              <div key={step.title}>
                <span>0{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
